
import TestApi from './components/TestApi';

function App() {
  return (
    <div className="App">
      <TestApi/>
    </div>
  );
}

export default App;
